import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门爆料</h2>
            <p className="text-sm text-foreground-600 mt-2">编辑精选优质爆料内容，深度挖掘每一个瓜背后的故事</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[4/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 inline-block px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{item.excerpt}</p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.stat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}